import {YouTubeVideoThumbnailType} from "../../definitions/types";

export class YouTubeThumbnailModel {
    private readonly _url: string;
    private readonly _width?: number;
    private readonly _height?: number;

    constructor({url, width, height}: YouTubeVideoThumbnailType) {
        this._url = url;
        this._width = width;
        this._height = height;
    }

    /**
     * @property url
     * @description The URL of the thumbnail image.
     * @returns {string}
     */
    public get url(): string {
        return this._url;
    }

    /**
     * @property width
     * @description (Optional) Width of the thumbnail image.
     * @returns {number}
     */
    public get width(): number | undefined {
        return this._width;
    }

    /**
     * @property height
     * @description (Optional) Height of the thumbnail image.
     * @returns {number}
     */
    public get height(): number | undefined {
        return this._height;
    }
}